// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c3b8abd","453":"bb23524c","732":"dc2cb487","977":"829b4f0c"}[chunkId] + ".chunk.js";
};